import { useAppSelector } from 'store';
import { selectPaymentsEnableWebTrader } from 'store/payments';
import { HistoryWT } from './HistoryWT';
import { HistoryMT } from './HistoryMT';
import { usePageTitle } from 'hooks/usePageTitle';
import { FormattedMessage, useIntl } from 'react-intl';

const History = () => {
  const intl = useIntl();

  const ENABLE_WT = useAppSelector(selectPaymentsEnableWebTrader);

  usePageTitle(
    intl.formatMessage({
      id: 'page.trading.history.title',
      defaultMessage: 'Trading History',
    }),
  );

  return (
    <>
      <h1>
        <FormattedMessage id="menu.trading" defaultMessage="Trading" />
      </h1>
      {ENABLE_WT ? <HistoryWT /> : <HistoryMT />}
    </>
  );
};

export default History;
